module.exports = __webpack_public_path__ + "static/stopklatka-7-c9cd2103615eb9908926241360898207.jpg";